import { render } from "./LatestBlock.vue?vue&type=template&id=5f7cd47e"
const script = {}
script.render = render

export default script